'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var MQ_BREAKPOINTS = exports.MQ_BREAKPOINTS = {
    mobile: '640',
    tablet: '740',
    desktop: '1024',
    wide: '1300'
};

var MAP_STYLES = exports.MAP_STYLES = [{
    featureType: 'water',
    elementType: 'all',
    stylers: [{
        hue: '#76aee3'
    }, {
        saturation: 38
    }, {
        lightness: -11
    }, {
        visibility: 'on'
    }]
}, {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{
        color: '#d1d1b9'
    }]
}, {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{
        color: '#d1d1b9'
    }]
}, {
    featureType: 'poi.park',
    elementType: 'all',
    stylers: [{
        hue: '#c6e3a4'
    }, {
        saturation: 17
    }, {
        lightness: -2
    }, {
        visibility: 'on'
    }]
}, {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [{
        'color': '#d1d1b9'
    }]
}, {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{
        color: '#d1d1b9'
    }]
}, {
    featureType: 'administrative.land_parcel',
    elementType: 'all',
    stylers: [{
        hue: '#5f5855'
    }, {
        saturation: 6
    }, {
        lightness: -31
    }, {
        visibility: 'on'
    }]
}, {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [{
        color: '#d1d1b9'
    }, {
        weight: 0.5
    }]
}, {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [{
        color: '#d1d1b9'
    }]
}, {
    featureType: 'water',
    elementType: 'all',
    stylers: []
}];


// WEBPACK FOOTER //
// ./scripts/util/constants.js